"use strict"

const MAX_RETRIES = 2
const RETRY_DELAY_MS = 1000

export function authInterceptor($rootScope, $q, $cookies, $injector) {
  "ngInject"

  var state
  var $http

  function getHttp() {
    if (!$http) {
      $http = $injector.get("$http")
    }
    return $http
  }

  function retryRequest(config, attempt) {
    return $q((resolve) => {
      setTimeout(() => {
        resolve(getHttp()(config))
      }, RETRY_DELAY_MS * Math.pow(2, attempt))
    })
  }

  function broadcastError(title, message) {
    $rootScope.$broadcast("api-error", { title, message, type: "error" })
  }

  return {
    request(config) {
      config.headers = config.headers || {}
      if ($cookies.get("token") && (config.url.startsWith("/api") || config.url.startsWith("/auth"))) {
        config.headers.Authorization = `Bearer ${$cookies.get("token")}`
      }
      return config
    },

    responseError(response) {
      state = state || $injector.get("$state")

      // 401 - redirect to login
      if (response.status === 401) {
        $cookies.remove("token")
        state.go("login")
        return $q.reject(response)
      }

      // 503 with rate limit message - broadcast to rate limit handler, no retry
      if (response.status === 503 && response.data?.error) {
        if (
          response.data.error.includes("system is very busy") ||
          response.data.error.includes("try again later")
        ) {
          $rootScope.$broadcast("gemapark-rate-limit", {
            message: response.data.error,
            activeSessions: response.data.activeSessions,
            maxSessions: response.data.maxSessions,
          })
          return $q.reject(response)
        }
      }

      // 502, 503 - retry with backoff
      if ([502, 503].includes(response.status)) {
        response.config._retryCount = (response.config._retryCount || 0) + 1

        if (response.config._retryCount <= MAX_RETRIES) {
          $rootScope.$broadcast("api-error", {
            title: "Retrying Request",
            message: `Attempt ${response.config._retryCount} of ${MAX_RETRIES}...`,
            type: "info",
          })
          return retryRequest(response.config, response.config._retryCount - 1)
        }

        // Retries exhausted
        broadcastError("Server Error", response.data?.error || `Request failed with status ${response.status}`)
        return $q.reject(response)
      }

      // 500, 504 - server errors
      if ([500, 504].includes(response.status)) {
        broadcastError("Server Error", response.data?.message || "Sorry, something went wrong. Please try again.")
        return $q.reject(response)
      }

      // Network error
      if (response.status === -1) {
        broadcastError("Connection Error", "Unable to reach the server. Please check your internet connection.")
        return $q.reject(response)
      }

      return $q.reject(response)
    },
  }
}
